import React, { useState, useEffect } from 'react';
import './App.css';
import Aside from './components/Aside';
import MainBody from './components/MainBody';
import 'bootstrap/dist/css/bootstrap.min.css';

const App: React.FC = () => {
  const [theme] = useState<'light' | 'dark'>(
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );

  useEffect(() => {
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(theme);
  }, [theme]);

  return (
    <div className={`App ${theme}`}>
      {/* Theme toggle moved to Aside */}
      <div className="main-content-layout">
        <Aside/>
        <MainBody/>
      </div>
    </div>
  );
}

export default App;
